export default __webpack_public_path__ + "assets/images/icon-quotes.36b00ee978b3fa7a8842a344f64840c0.svg";